import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { VolunteerOrgActivityDomain } from "../volunteer-org-activity-domain";
import { VolunteerOrganization } from "../volunteer-organization";
import { VolunteerOrgActivityEntityConfig } from "./config";
import { VolunteerOrgActivityFilters } from "./filters";
import { VolunteerOrgActivityMethods } from "./methods";

@HyperEntity("volunteer-org-activity", VolunteerOrgActivityEntityConfig)
export class VolunteerOrgActivity extends extender(
  VolunteerOrgActivityFilters,
  VolunteerOrgActivityMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "volunteer_organization_id" })
  volunteerOrganizationId = "";

  @Relations.toOne<VolunteerOrgActivity, VolunteerOrganization>(
    () => VolunteerOrganization,
    "volunteerOrganizationId",
  )
  volunteerOrganization?: VolunteerOrganization;

  @Fields.string({ dbName: "domain_id" })
  domainId = "";

  @Relations.toOne<VolunteerOrgActivity, VolunteerOrgActivityDomain>(
    () => VolunteerOrgActivityDomain,
    "domainId",
  )
  domain?: VolunteerOrgActivityDomain;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
